import './ChatHistory.css';
import '../../pages/layout/NewLayout.css';
import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";
import ChatHistoryList from "./ChatHistoryList";
import { ChatHistoryLoadingState } from "../../constants/enums";

export function ChatHistoryPanel() {
    const appStateContext = useContext(AppStateContext)


    return (
        <section className='' data-is-scrollable aria-label={"recent activity panel"}>
            <div>
                {
                    ((appStateContext?.state.chatHistory || appStateContext?.state.chatHistoryLoadingState == ChatHistoryLoadingState.Success) 
                        && appStateContext?.state.isDynamoDBAvailable.dynamoDB ) ? (
                        <ChatHistoryList/>
                    ): appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading ?(
                        <div className='c-default ms-3'>Loading session history...</div>
                    ) : (
                        <div className='c-default ms-3'>Error loading session history</div>
                    )
                }
            </div>
        </section>
    );
}